import React, { useState, useEffect } from 'react';
import { FiSun, FiMoon, FiMenu, FiX } from 'react-icons/fi';
import styles from './Navbar.module.css';
import { useLanguage } from '../../context/LanguageContext';
import { useTheme } from '../../context/ThemeContext';
import { Language } from '../../types';

const Navbar: React.FC = () => {
  const { t, language, setLanguage } = useLanguage();
  const { theme, toggleTheme } = useTheme();
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [langOpen, setLangOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
    setMenuOpen(false);
  };

  const navItems = [
    { key: 'about', label: t.nav.about },
    { key: 'experience', label: t.nav.experience },
    { key: 'youtube', label: t.nav.youtube },
    { key: 'blog', label: t.nav.blog },
    { key: 'contact', label: t.nav.contact },
  ];

  return (
    <header className={`${styles.navbar} ${scrolled ? styles.scrolled : ''}`}>
      <div className={styles.logo}>
        nuricanakturk<span>.</span>com
      </div>

      <nav>
        <ul className={`${styles.nav} ${menuOpen ? styles.open : ''}`}>
          {navItems.map(item => (
            <li key={item.key}>
              <span className={styles.navLink} onClick={() => scrollTo(item.key)}>
                {item.label}
              </span>
            </li>
          ))}
        </ul>
      </nav>

      <div className={styles.controls}>
        <div className={styles.langDropdown}>
          <button
            className={`${styles.iconBtn} ${styles.langBtn}`}
            onClick={() => setLangOpen(o => !o)}
            title="Language"
          >
            {language.toUpperCase()}
          </button>
          {langOpen && (
            <div className={styles.langMenu}>
              {(['en', 'tr', 'es', 'nl'] as Language[]).map(l => (
                <button
                  key={l}
                  className={`${styles.langOption} ${language === l ? styles.activeLang : ''}`}
                  onClick={() => { setLanguage(l); setLangOpen(false); }}
                >
                  {l.toUpperCase()}
                </button>
              ))}
            </div>
          )}
        </div>
        <button
          className={styles.iconBtn}
          onClick={toggleTheme}
          title="Toggle theme"
        >
          {theme === 'dark' ? <FiSun /> : <FiMoon />}
        </button>
        <button
          className={`${styles.iconBtn} ${styles.menuBtn}`}
          onClick={() => setMenuOpen(!menuOpen)}
          title="Menu"
        >
          {menuOpen ? <FiX /> : <FiMenu />}
        </button>
      </div>
    </header>
  );
};

export default Navbar;
